import Page from 'src/event/[entityId]/embed/index';

export default Page;
